function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Component } from "react";
import { findDOMNode } from "react-dom";
import h from "@macrostrat/hyper";

var ConfinedImage = /*#__PURE__*/function (_Component) {
  _inherits(ConfinedImage, _Component);

  var _super = _createSuper(ConfinedImage);

  function ConfinedImage(props) {
    var _this;

    _classCallCheck(this, ConfinedImage);

    _this = _super.call(this, props);
    _this.state = {
      imageSize: null
    };
    return _this;
  }

  _createClass(ConfinedImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          maxHeight = _this$props.maxHeight,
          maxWidth = _this$props.maxWidth,
          src = _this$props.src;
      var imageSize = this.state.imageSize;

      if (maxHeight == null) {
        maxHeight = 200;
      }

      if (maxWidth == null) {
        maxWidth = 200;
      }

      if (imageSize != null) {
        if (maxHeight > imageSize.height) {
          maxHeight = imageSize.height;
        }

        if (maxWidth > imageSize.width) {
          maxWidth = imageSize.width;
        }
      }

      var imgStyle = {
        maxHeight: maxHeight,
        maxWidth: maxWidth
      };
      var style = {
        maxHeight: maxHeight,
        maxWidth: maxWidth
      };
      return h("div.image-container", {
        style: style
      }, [h("img", {
        src: src,
        style: imgStyle
      })]);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var el = findDOMNode(this); // @ts-ignore

      var img = el.querySelector("img");
      return img.onload = function () {
        var height = img.naturalHeight / 2;
        var width = img.naturalWidth / 2;
        return _this2.setState({
          imageSize: {
            height: height,
            width: width
          }
        });
      };
    }
  }]);

  return ConfinedImage;
}(Component);

export { ConfinedImage };